import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDataProvider } from 'react-admin'
import { EntityRef, getEntityEditUrl } from '../services/entityRef'
import useStyles from '../styles'
import CopyButton from './CopyButton'

interface EntityBlockProps {
  entityRef: EntityRef
}

const EntityBlock: React.FC<EntityBlockProps> = ({ entityRef }) => {
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const { id, typeName, resource } = entityRef

  const { data: name, isError } = useQuery({
    queryKey: ['logViewer', 'entity', resource, id],
    enabled: resource != null,
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const { data } = await dataProvider.getOne(resource as string, { id })
      const record = data as { name?: unknown }
      return typeof record.name === 'string' && record.name !== ''
        ? record.name
        : null
    },
  })

  const openLabel = `Open ${typeName !== '' ? typeName : 'entity'} page`

  return (
    <div>
      <div className={classes.detailLabel}>
        Entity{typeName !== '' ? ` — ${typeName}` : ''}
      </div>
      {name != null && <div className={classes.detailValue}>{name}</div>}
      {isError && <div className={classes.detailValue}>(not found)</div>}
      <div className={classes.detailValueRow}>
        <span className={classes.detailValue}>{id}</span>
        <CopyButton
          value={id}
          label='Copy Entity ID'
        />
        {resource != null && (
          <button
            type='button'
            className={classes.traceFilterButton}
            title={openLabel}
            aria-label={openLabel}
            onClick={() =>
              window.open(getEntityEditUrl(resource, id), '_blank', 'noopener')
            }
          >
            <span
              className='material-symbols-outlined'
              style={{ fontSize: 14 }}
            >
              open_in_new
            </span>
            Open
          </button>
        )}
      </div>
    </div>
  )
}

export default EntityBlock
